import { render, staticRenderFns } from "./BuildingActivityAreaForm.vue?vue&type=template&id=62bae63b"
import script from "./BuildingActivityAreaForm.vue?vue&type=script&lang=js"
export * from "./BuildingActivityAreaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports